module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/design_type_of_pastel-2f1c540aadc02c2a71dde7e1779dcc5a.png";